@if ({ value: vm$ | async }; as vm) {
    <mds-dialog dialogTitle="Upload Sites from Spreadsheet">
        <mds-dialog-content>
            <div class="o-grid">
                <div class="o-grid__row">
                    <div class="o-grid__item">
                        <div class="example-custom-placeholder" *cdkDragePlaceholder></div>
                        <medpace-upload
                            [acceptableTypes]="acceptableFileTypes"
                            (emitStuff)="getSpreadsheet($event)"
                            uploadButtonTitle="Upload Spreadsheet"
                        >
                        </medpace-upload>
                    </div>
                </div>
                @if (vm.value !== null) {
                    <div>
                        @if (vm.value.parsingResult !== null) {
                            <div class="o-grid__row">
                                <div class="o-grid__item">
                                    @if (vm.value.parsingResult.isSuccess === true) {
                                        <div style="color: green">Correct file schema</div>
                                    }
                                    @if (vm.value.parsingResult.isSuccess === false) {
                                        <div style="color: red">Incorrect file schema</div>
                                    }
                                </div>
                            </div>
                        }
                        @if (vm.value.dataErrors.length !== 0) {
                            <div>
                                @for (error of vm.value.dataErrors; track error) {
                                    <div class="o-grid__row">
                                        <div class="o-grid__item">
                                            <div style="color: red">{{ error }}</div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        @if (vm.value.canBeUploaded === true) {
                            <div>
                                <div class="o-grid__row">
                                    <div class="o-grid__item">
                                        <p>You are about to add {{ vm.value.sites.length }} sites to your study</p>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </mds-dialog-content>
        <mds-dialog-actions [align]="'end'">
            <div class="flex flex-row gap-medpace">
                <mds-button
                    [id]="'cancel-btn'"
                    mat-button
                    mat-dialog-close
                    variant="outline"
                    label="Cancel"
                    width="auto"
                    (clickEvent)="onCancelClicked()"
                ></mds-button>
                <mds-button
                    [id]="'site-submit-btn'"
                    [disabled]="!(vm.value !== null && vm.value.canBeUploaded === true)"
                    mat-button
                    [color]="'primary'"
                    [variant]="'filled'"
                    label="Submit"
                    width="auto"
                    (clickEvent)="onSubmitClicked()"
                ></mds-button>
            </div>
        </mds-dialog-actions>
    </mds-dialog>
}
